// @ts-strict-ignore
import React from 'react';
import { Visibility } from 'common/components/base/stackable';
import { ModalReact } from 'common/components/modal';
import { SvgIconReact } from 'common/components/svg-icon';
import { ButtonReact } from 'common/components/button';
import { ButtonSize, ButtonTheme } from 'common/components/button/constants';
import { withStyles } from 'common/util/react';
import { react2panel } from 'common/util/react2panel';
import { useTranslation } from 'common/i18n/hooks';
import { ProductUpdate } from 'app_api/product_updates/types';
import css from './index.module.styl?inline';
import styles from './index.module.styl';
type ChangelogModalProps = {
  productUpdates: ProductUpdate[];
  onCloseHandler: () => void;
};
const READ_MORE_CLICKED = "[Changelog] Read More link clicked";
const WATCH_LOOM_CLICKED = "[Changelog] Watch the Loom link clicked";
const FULL_CHANGELOG_CLICKED = "[Changelog] See the Full Changelog clicked";
const FEATURE_NAME_PROP = "feature name";
const changelogUrl = "https://docs.mixpanel.com/changelogs";
const NUM_OF_UPDATES_TO_SHOW = 3;
function ChangelogModal(props: ChangelogModalProps) {
  const {
    t
  } = useTranslation();
  const formatProductUpdate = (update: ProductUpdate) => {
    return <div className={styles.updateContainer} data-sentry-component="formatProductUpdate" data-sentry-source-file="index.tsx">
        <div className={styles.dateWrapper}> {update.release_date}</div>
        <div className={styles.updateContent}>
          <div className={styles.updateLabel}> {update.label} </div>
          <div className={styles.updateDescription}>
            {update.description + " "}
            <a onClick={() => mixpanel.track(READ_MORE_CLICKED, {
            'read more url': update.link,
            [FEATURE_NAME_PROP]: update.label
          })} className={styles.readMoreLink} href={update.link} target='_blank'>
              {t("help.changelog-modal.read-more")}
            </a>
          </div>
          {update.video_link && <div className={styles.loomContainer}>
              <SvgIconReact icon={"play-video"} />
              <a onClick={() => mixpanel.track(WATCH_LOOM_CLICKED, {
            'loom url': update.video_link,
            [FEATURE_NAME_PROP]: update.label
          })} href={update.video_link} target='_blank' className={styles.loom}>
                {t("help.changelog-modal.watch-loom")}
              </a>
            </div>}
        </div>
      </div>;
  };
  const sortAndReturnUpdates = (): ProductUpdate[] => {
    // copy and sort by date
    return props.productUpdates.slice().sort((a, b) => new Date(b.release_date).getTime() - new Date(a.release_date).getTime());
  };
  return <div elref='changelogModal' data-sentry-component="ChangelogModal" data-sentry-source-file="index.tsx">
      <ModalReact className={styles.modal} closeable open onChange={(event: CustomEvent) => {
      if (event.detail.state === Visibility.Closed) {
        props.onCloseHandler();
      }
    }} data-sentry-element="ModalReact" data-sentry-source-file="index.tsx">
        <div className={styles.modalContent}>
          <div className={styles.title}> {t("help.changelog-modal.whats-new")}</div>
          <div>
            {props.productUpdates && sortAndReturnUpdates().slice(0, NUM_OF_UPDATES_TO_SHOW).map((productUpdate: ProductUpdate) => {
            return formatProductUpdate(productUpdate);
          })}
          </div>
          <div className={styles.buttonContainer}>
            <ButtonReact onClick={() => {
            mixpanel.track(FULL_CHANGELOG_CLICKED);
            window.open(changelogUrl, "_blank").focus();
          }} className={styles.changelogButton} theme={ButtonTheme.Primary} size={ButtonSize.Large} data-sentry-element="ButtonReact" data-sentry-source-file="index.tsx">
              {t("help.changelog-modal.see-full-changelog")}
            </ButtonReact>
          </div>
        </div>
      </ModalReact>
    </div>;
}
export const ChangeModalReact = withStyles(ChangelogModal, css);
export const ChangelogModalEl = react2panel("mp-changelog-modal", ChangeModalReact);